module.exports = "/assets/images/placeholder.29315c8113fcffa95f187a11e482af49.png";